document.addEventListener('DOMContentLoaded', () => {
  const themeConfig = window.theme || {};
  const headerRoot = document.querySelector('.custom-header[data-section-id]');
  if (!headerRoot) return;

  const sectionId = headerRoot.dataset.sectionId;
  const sectionConfig = themeConfig.sections?.header?.[sectionId] || {};
  const routes = themeConfig.routes || {};
  const cartUrl = routes.cart || '/cart';
  const cartChangeUrl = routes.cartChange || '/cart/change';
  const predictiveSearchUrl = routes.predictiveSearch || '/search/suggest';
  const searchUrl = routes.search || '/search';
  const enableCleanUrls = Boolean(themeConfig.settings?.enableCleanUrls);
  const currencySymbol = themeConfig.currencySymbol || '';
  const cartSectionsUrl = window.location.pathname + window.location.search;

  const CustomHeader = {
    selectors: {
      overlay: '#custom-header-overlay',
      cartDrawer: '#custom-header-cart-drawer',
      mobileDrawer: '#custom-header-mobile-drawer',
      cartTrigger: '#custom-header-cart-trigger',
      mobileTrigger: '#custom-header-mobile-trigger',
      closeCartBtn: '#custom-header-close-cart-drawer',
      closeMobileBtn: '#custom-header-close-mobile-drawer',
      mobileNavContainer: '.custom-header__mobile-nav-container',
      searchInputMobile: '#custom-header-search-input-mobile',
      predictiveMobile: '#custom-header-predictive-results-mobile',
      searchOverlay: '#custom-header-search-overlay',
      searchOverlayTrigger: '#custom-header-search-overlay-trigger',
      searchOverlayInput: '#custom-header-search-input-overlay',
      searchOverlayResults: '#custom-header-search-overlay-results',
      cartCount: '#custom-header-cart-count',
      cartDrawerBody: '#custom-header-cart-drawer-body',
      cartDrawerFooter: '#custom-header-cart-drawer-footer',
      cartSubtotal: '#custom-header-cart-subtotal',
      cartTitle: '#custom-header-cart-title',
    },

      init() {
        this.activeDialog = null;
        this.focusReturnElement = null;
        this.cacheElements();
        this.bindEvents();
        this.initSearchOverlay();
      },

      cacheElements() {
        this.overlay = document.querySelector(this.selectors.overlay);
        this.cartDrawer = document.querySelector(this.selectors.cartDrawer);
        this.mobileDrawer = document.querySelector(this.selectors.mobileDrawer);
        this.cartTrigger = document.querySelector(this.selectors.cartTrigger);
        this.mobileTrigger = document.querySelector(this.selectors.mobileTrigger);
        this.closeCartBtn = document.querySelector(this.selectors.closeCartBtn);
        this.closeMobileBtn = document.querySelector(this.selectors.closeMobileBtn);
        this.mobileNavContainer = document.querySelector(this.selectors.mobileNavContainer);
        this.searchInputMobile = document.querySelector(this.selectors.searchInputMobile);
        this.predictiveMobile = document.querySelector(this.selectors.predictiveMobile);
        this.searchOverlay = document.querySelector(this.selectors.searchOverlay);
        this.searchOverlayTrigger = document.querySelector(this.selectors.searchOverlayTrigger);
        this.searchOverlayInput = document.querySelector(this.selectors.searchOverlayInput);
        this.searchOverlayResults = document.querySelector(this.selectors.searchOverlayResults);
        this.cartCount = document.querySelector(this.selectors.cartCount);
        this.cartDrawerBody = document.querySelector(this.selectors.cartDrawerBody);
        this.cartDrawerFooter = document.querySelector(this.selectors.cartDrawerFooter);
        this.cartSubtotal = document.querySelector(this.selectors.cartSubtotal);
        this.cartTitle = document.querySelector(this.selectors.cartTitle);
      },

      setDrawerBodySubmenuState(panel, isOpen) {
        const drawerBody = panel?.closest('.custom-header__drawer-body');
        if (!drawerBody) return;

        if (isOpen) {
          drawerBody.classList.add('custom-header__drawer-body--submenu-open');
          drawerBody.scrollTop = 0;
          panel.scrollTop = 0;
          return;
        }

        const hasActivePanels = drawerBody.querySelector('.custom-header__sub-menu-panel.active');
        drawerBody.classList.toggle('custom-header__drawer-body--submenu-open', Boolean(hasActivePanels));
      },

      bindEvents() {
        // Drawer triggers
        if (this.cartTrigger) {
          this.cartTrigger.addEventListener('click', (e) => {
            e.preventDefault();
            // Check if on cart page - reload instead of opening drawer
            if (window.location.pathname === '/cart' || window.location.pathname === cartUrl) {
              window.location.reload();
              return;
            }
            this.openDrawer(this.cartDrawer, this.cartTrigger);
          });
        }

        if (this.mobileTrigger) {
          this.mobileTrigger.addEventListener('click', () => this.openDrawer(this.mobileDrawer, this.mobileTrigger));
        }

        if (this.searchInputMobile) {
          this.searchInputMobile.addEventListener(
            'focus',
            () => {
              void this.ensurePredictiveSearch();
            },
            { once: true }
          );
        }

        // Close buttons
        if (this.closeCartBtn) this.closeCartBtn.addEventListener('click', () => this.closeAllDrawers());
        if (this.closeMobileBtn) this.closeMobileBtn.addEventListener('click', () => this.closeAllDrawers());
        if (this.overlay) this.overlay.addEventListener('click', () => this.closeAllDrawers());

        // Mobile drill-down menu
        if (this.mobileNavContainer) {
          this.mobileNavContainer.addEventListener('click', (e) => {
            const trigger = e.target.closest('.custom-header__menu-trigger');
            if (trigger) {
              const subMenu = trigger.nextElementSibling;
              if (subMenu && subMenu.classList.contains('custom-header__sub-menu-panel')) {
                subMenu.classList.add('active');
                subMenu.setAttribute('aria-hidden', 'false');
                trigger.setAttribute('aria-expanded', 'true');
                this.setDrawerBodySubmenuState(subMenu, true);
                this.focusFirstElement(subMenu);
              }
            }

            const backBtn = e.target.closest('.custom-header__back-btn');
            if (backBtn) {
              const currentPanel = backBtn.closest('.custom-header__sub-menu-panel');
              if (currentPanel) {
                currentPanel.classList.remove('active');
                currentPanel.setAttribute('aria-hidden', 'true');
                currentPanel.scrollTop = 0;
                this.setDrawerBodySubmenuState(currentPanel, false);
                const parentTrigger = currentPanel.previousElementSibling;
                if (parentTrigger) {
                  parentTrigger.setAttribute('aria-expanded', 'false');
                  parentTrigger.focus();
                }
              }
            }
          });
        }

        // Cart item actions
        document.addEventListener('click', (e) => {
          const actionBtn = e.target.closest('[data-action]');
          if (actionBtn && actionBtn.closest('.custom-header__cart-drawer')) {
            e.preventDefault();
            const action = actionBtn.dataset.action;
            const line = Number.parseInt(actionBtn.dataset.line || '', 10);
            this.handleCartAction(action, line);
          }
        });

        document.addEventListener('submit', (e) => {
          if (e.target?.id !== 'custom-header-cart-form' || e.submitter?.name !== 'checkout' || !window.CartApi?.validateCheckout) return;

          e.preventDefault();
          CartApi.validateCheckout()
            .then(() => {
              CartApi.submitFormWithSubmitter?.(e.target, e.submitter);
            })
            .catch((error) => {
              CartApi.showToast(error.message, true);
            });
        });

        // Escape key closes drawers and search overlay
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Tab') {
            this.trapFocus(e);
            return;
          }

          if (e.key === 'Escape') {
            if (this.searchOverlay?.classList.contains('active')) {
              e.preventDefault();
              this.closeSearchOverlay();
              return;
            }

            if (this.cartDrawer?.classList.contains('open') || this.mobileDrawer?.classList.contains('open')) {
              e.preventDefault();
              this.closeAllDrawers();
            }
          }
        });

        // Listen for global cart refresh events (e.g. from product cards)
        document.addEventListener('cart:refresh', (e) => {
          if (e.detail) {
            this.updateCartUI(e.detail);
          }
        });
      },

      openDrawer(drawer, trigger = null) {
        if (!drawer) return;
        this.closeSearchOverlay(false);
        drawer.classList.add('open');
        drawer.removeAttribute('hidden');
        drawer.setAttribute('aria-hidden', 'false');
        this.overlay.classList.add('active');
        document.body.style.overflow = 'hidden';
        this.setActiveDialog(drawer, trigger || document.activeElement);

        // Update trigger aria-expanded
        if (drawer === this.cartDrawer) {
          this.cartTrigger?.setAttribute('aria-expanded', 'true');
        } else if (drawer === this.mobileDrawer) {
          this.mobileTrigger?.setAttribute('aria-expanded', 'true');
        }

        window.requestAnimationFrame(() => {
          const preferredFocus = drawer === this.mobileDrawer ? this.closeMobileBtn || this.mobileDrawer : this.closeCartBtn;
          (preferredFocus || this.getFocusableElements(drawer)[0])?.focus();
        });
      },

      closeAllDrawers(restoreFocus = true) {
        const hadOpenDrawer = this.cartDrawer?.classList.contains('open') || this.mobileDrawer?.classList.contains('open');

        [this.cartDrawer, this.mobileDrawer].forEach((drawer) => {
          if (drawer) {
            drawer.classList.remove('open');
            drawer.setAttribute('hidden', '');
            drawer.setAttribute('aria-hidden', 'true');
          }
        });

        this.overlay?.classList.remove('active');
        document.body.style.overflow = '';

        // Reset aria-expanded
        this.cartTrigger?.setAttribute('aria-expanded', 'false');
        this.mobileTrigger?.setAttribute('aria-expanded', 'false');

        if (hadOpenDrawer) {
          this.clearActiveDialog(restoreFocus);
        }

        if (this.searchInputMobile) {
          this.searchInputMobile.value = '';
        }

        if (this.predictiveMobile) {
          this.predictiveMobile.classList.remove('active');
          this.predictiveMobile.innerHTML = '';
        }

        // Reset mobile menu panels after transition
        setTimeout(() => {
          document.querySelectorAll('.custom-header__sub-menu-panel.active').forEach((panel) => {
            panel.classList.remove('active');
            panel.setAttribute('aria-hidden', 'true');
            panel.scrollTop = 0;
            this.setDrawerBodySubmenuState(panel, false);
          });
        }, 300);
      },

      /* --- Desktop Search Overlay --- */
      initSearchOverlay() {
        if (!this.searchOverlay) return;

        // Open overlay on icon click
        if (this.searchOverlayTrigger) {
          this.searchOverlayTrigger.addEventListener('click', () => {
            this.openSearchOverlay();
            void this.ensurePredictiveSearch();
          });
        }

        // Close overlay on backdrop or close button click
        this.searchOverlay.querySelectorAll('[data-search-overlay-close]').forEach(el => {
          el.addEventListener('click', () => this.closeSearchOverlay());
        });

        if (this.searchOverlayInput) {
          this.searchOverlayInput.addEventListener(
            'focus',
            () => {
              void this.ensurePredictiveSearch();
            },
            { once: true }
          );
        }
      },

      ensurePredictiveSearch() {
        if (this.predictiveSearchInstance) {
          return Promise.resolve(this.predictiveSearchInstance);
        }

        if (!this.searchModuleUrl) {
          return Promise.resolve(null);
        }

        if (!this.predictiveSearchPromise) {
          this.predictiveSearchPromise = this.loadScript(this.searchModuleUrl)
            .then(() => {
              const predictiveSearch = window.CustomHeaderPredictiveSearch;
              if (!predictiveSearch) return null;

              this.predictiveSearchInstance = predictiveSearch.init({
                mobileInput: this.searchInputMobile,
                mobileResults: this.predictiveMobile,
                overlayInput: this.searchOverlayInput,
                overlayResults: this.searchOverlayResults,
                predictiveSearchUrl,
                searchUrl,
                enableCleanUrls,
                formatPrice: (price) => this.formatPredictivePrice(price),
              });

              return this.predictiveSearchInstance;
            })
            .catch((error) => {
              console.error('Failed to load predictive search:', error);
              this.predictiveSearchPromise = null;
              return null;
            });
        }

        return this.predictiveSearchPromise;
      },

      loadScript(url) {
        if (!url) return Promise.resolve();
        if (document.querySelector(`script[data-header-search-script="${url}"]`)) {
          return Promise.resolve();
        }

        return new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = url;
          script.async = true;
          script.dataset.headerSearchScript = url;
          script.onload = () => resolve();
          script.onerror = () => reject(new Error(`Unable to load script: ${url}`));
          document.head.appendChild(script);
        });
      },

      openSearchOverlay() {
        if (!this.searchOverlay) return;
        this.closeAllDrawers(false);

        // Calculate the header's bottom edge to position the overlay
        const headerSection = document.getElementById(`shopify-section-${sectionId}`);
        if (headerSection) {
          const headerRect = headerSection.getBoundingClientRect();
          this.searchOverlay.style.top = headerRect.bottom + 'px';
          this.searchOverlay.style.height = `calc(100vh - ${headerRect.bottom}px)`;
          this.searchOverlay.style.height = `calc(100dvh - ${headerRect.bottom}px)`;
        }

        this.searchOverlay.classList.add('active');
        this.searchOverlay.setAttribute('aria-hidden', 'false');
        this.searchOverlayTrigger?.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
        this.setActiveDialog(this.searchOverlay, this.searchOverlayTrigger);

        // Focus the search input after animation
        setTimeout(() => {
          this.searchOverlayInput?.focus();
        }, 150);
      },

      closeSearchOverlay(restoreFocus = true) {
        if (!this.searchOverlay) return;
        const isOpen = this.searchOverlay.classList.contains('active');
        this.searchOverlay.classList.remove('active');
        this.searchOverlay.setAttribute('aria-hidden', 'true');
        this.searchOverlayTrigger?.setAttribute('aria-expanded', 'false');
        if (!(this.cartDrawer?.classList.contains('open') || this.mobileDrawer?.classList.contains('open'))) {
          document.body.style.overflow = '';
        }

        if (isOpen) {
          this.clearActiveDialog(restoreFocus);
        }

        // Clear search after close transition
        setTimeout(() => {
          if (this.searchOverlayInput) this.searchOverlayInput.value = '';
          this.predictiveSearchInstance?.resetOverlayResults();
        }, 300);
      },

      getSectionMarkup(payload) {
        if (!payload?.sections) return '';
        return payload.sections[sectionId] || Object.values(payload.sections)[0] || '';
      },

      updateCartBadges(itemCount) {
        if (itemCount == null) return;

        document.querySelectorAll('.custom-header__cart-count').forEach((element) => {
          element.textContent = itemCount;
          element.classList.toggle('hidden', itemCount === 0);
        });

        [this.cartTrigger, this.mobileTrigger].forEach((trigger) => {
          if (trigger) {
            trigger.dataset.cartCount = itemCount;
          }
        });
      },

      applyCartSectionMarkup(sectionMarkup, fallbackCart = null) {
        if (!sectionMarkup) return false;

        const parser = new DOMParser();
        const doc = parser.parseFromString(sectionMarkup, 'text/html');

        const newTitle = doc.querySelector('#custom-header-cart-title');
        const newBody = doc.querySelector('#custom-header-cart-drawer-body');
        const newFooter = doc.querySelector('#custom-header-cart-drawer-footer');
        const newSubtotal = doc.querySelector('#custom-header-cart-subtotal');
        const countSource =
          doc.querySelector('#custom-header-cart-count') ||
          doc.querySelector('#custom-header-cart-drawer-count');

        const parsedCount = Number.parseInt(countSource?.textContent?.trim() || '', 10);
        const itemCount = Number.isNaN(parsedCount) ? fallbackCart?.item_count : parsedCount;

        if (newTitle && this.cartTitle) {
          this.cartTitle.innerHTML = newTitle.innerHTML;
        } else if (this.cartTitle && itemCount != null) {
          const cartTitleText = sectionConfig.cartTitle || 'Shopping Cart';
          this.cartTitle.textContent = `${cartTitleText} (${itemCount})`;
        }

        if (newBody && this.cartDrawerBody) {
          this.cartDrawerBody.innerHTML = newBody.innerHTML;
        }

        if (newFooter && this.cartDrawerFooter) {
          this.cartDrawerFooter.innerHTML = newFooter.innerHTML;
        }

        if (newSubtotal && this.cartSubtotal) {
          this.cartSubtotal.innerHTML = newSubtotal.innerHTML;
        } else if (this.cartSubtotal && fallbackCart?.total_price != null) {
          this.cartSubtotal.textContent = this.formatMoney(fallbackCart.total_price);
        }

        if (this.cartDrawerFooter && itemCount != null) {
          this.cartDrawerFooter.style.display = itemCount > 0 ? '' : 'none';
        }

        this.updateCartBadges(itemCount);
        return true;
      },

      async handleCartAction(action, line) {
        if (!Number.isInteger(line) || line < 1) return;

        let quantity = 0;
        const lineItem = document.querySelector(`[data-line-item-index="${line}"]`);
        const variantId = lineItem?.dataset.variantId || '';
        const currentQty = lineItem
          ? parseInt(lineItem.querySelector('.custom-header__qty-value')?.textContent || 0)
          : 0;
        switch (action) {
          case 'increase':
            quantity = currentQty + 1;
            break;
          case 'decrease':
            quantity = Math.max(0, currentQty - 1);
            break;
          case 'remove':
            quantity = 0;
            break;
        }

        if (action === 'increase') {
          try {
            const cart = await CartApi.getCart();

            if (window.CartApi?.isHighRiskManagementEnabled?.()) {
              const projectedTotal = CartApi.getItemCount(cart) - currentQty + quantity;
              await CartApi.validateProjectedCartQuantity(projectedTotal);
            }

            CartApi.validateCartVariantQuantity({
              cart,
              variantId,
              inventoryData: lineItem?.dataset,
              nextQuantity: quantity,
              excludeLine: line,
            });
          } catch (error) {
            CartApi.showToast(error.message, true);
            return;
          }
        }

        if (this.cartDrawerBody) {
          this.cartDrawerBody.classList.add('custom-header__cart-drawer-body--loading');
        }

        try {
          const response = await fetch(cartChangeUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({
              line,
              quantity,
              sections: sectionId,
              sections_url: cartSectionsUrl,
            }),
          });

          const data = await response.json();

          if (!response.ok || data.status) {
            // Cart API returned an error (e.g. 400, 422)
            const errorMsg = data.description || data.message || 'Something went wrong updating cart';
            if (typeof CartApi !== 'undefined' && CartApi.showToast) {
              CartApi.showToast(errorMsg, true);
            }
            // Remove loading state without corrupting the UI
            if (this.cartDrawerBody) {
              this.cartDrawerBody.classList.remove('custom-header__cart-drawer-body--loading');
            }
            return;
          }

          await this.updateCartUI(data);
        } catch (error) {
          console.error('Cart update error:', error);
          if (typeof CartApi !== 'undefined' && CartApi.showToast) {
            CartApi.showToast('Something went wrong. Please try again.', true);
          }
          // Remove loading state on network error
          if (this.cartDrawerBody) {
            this.cartDrawerBody.classList.remove('custom-header__cart-drawer-body--loading');
          }
        }
      },

      async updateCartUI(cart) {
        return new Promise((resolve) => {
          window.CartApi?.setCartCache?.(cart);
          const appliedSections = this.applyCartSectionMarkup(this.getSectionMarkup(cart), cart);

          if (appliedSections) {
            if (this.cartDrawerBody) {
              this.cartDrawerBody.classList.remove('custom-header__cart-drawer-body--loading');
            }
            resolve();
            return;
          }

          if (cart?.item_count != null) {
            this.updateCartBadges(cart.item_count);
          }

          if (this.cartTitle && cart?.item_count != null) {
            const cartTitleText = sectionConfig.cartTitle || 'Shopping Cart';
            this.cartTitle.textContent = `${cartTitleText} (${cart.item_count})`;
          }

          if (this.cartSubtotal && cart?.total_price != null) {
            this.cartSubtotal.textContent = this.formatMoney(cart.total_price);
          }

          fetch(`${cartUrl}?section_id=${encodeURIComponent(sectionId)}`)
            .then((response) => response.text())
            .then((html) => {
              this.applyCartSectionMarkup(html, cart);

              if (this.cartDrawerBody) {
                this.cartDrawerBody.classList.remove('custom-header__cart-drawer-body--loading');
              }

              resolve();
            })
            .catch((error) => {
              console.error('Cart UI update error:', error);
              // Remove loading state even on error
              if (this.cartDrawerBody) {
                this.cartDrawerBody.classList.remove('custom-header__cart-drawer-body--loading');
              }
              resolve();
            });
        });
      },

      formatMoney(cents) {
        const amount = (cents / 100).toFixed(2);
        return currencySymbol + amount;
      },
      formatPredictivePrice(price) {
        if (window.theme?.moneyDecimals === '0' && typeof price === 'string') {
          return price.replace(/([.,]\d{2})(?!\d)/g, '');
        }
        return price;
      },
      setActiveDialog(dialog, returnFocusElement) {
        this.activeDialog = dialog;
        this.focusReturnElement = returnFocusElement || document.activeElement || null;
      },
      clearActiveDialog(restoreFocus = true) {
        const returnFocusElement = this.focusReturnElement;
        this.activeDialog = null;
        this.focusReturnElement = null;

        if (restoreFocus && returnFocusElement?.focus) {
          window.requestAnimationFrame(() => {
            returnFocusElement.focus();
          });
        }
      },
      getFocusableElements(container) {
        if (!container) return [];

        return Array.from(
          container.querySelectorAll(
            'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
          )
        ).filter(
          (element) =>
            !element.hasAttribute('hidden') &&
            element.getAttribute('aria-hidden') !== 'true' &&
            (element.offsetParent !== null || element === document.activeElement)
        );
      },
      focusFirstElement(container) {
        this.getFocusableElements(container)[0]?.focus();
      },
      trapFocus(event) {
        if (event.key !== 'Tab' || !this.activeDialog) return;

        const focusableElements = this.getFocusableElements(this.activeDialog);
        if (!focusableElements.length) return;

        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];

        if (event.shiftKey && document.activeElement === firstElement) {
          event.preventDefault();
          lastElement.focus();
        } else if (!event.shiftKey && document.activeElement === lastElement) {
          event.preventDefault();
          firstElement.focus();
        }
      },
    };

  CustomHeader.searchModuleUrl = sectionConfig.searchModuleUrl || '';
  CustomHeader.init();

  // Expose for external use
  window.CustomHeader = CustomHeader;
});
